// Browser-side lead cache (IndexedDB). Lets the CRM open with leads already on screen and
// only download rows that changed, instead of pulling every lead from Supabase on each visit.
const DB_NAME = 'tradelynx-crm';
const STORE = 'lead-cache';

function openDb() {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === 'undefined') {
      reject(new Error('IndexedDB unavailable'));
      return;
    }
    const request = indexedDB.open(DB_NAME, 1);
    request.onupgradeneeded = () => request.result.createObjectStore(STORE);
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

async function runStore(mode, action) {
  const db = await openDb();
  try {
    return await new Promise((resolve, reject) => {
      const tx = db.transaction(STORE, mode);
      const request = action(tx.objectStore(STORE));
      tx.oncomplete = () => resolve(request?.result);
      tx.onerror = () => reject(tx.error);
      tx.onabort = () => reject(tx.error);
    });
  } finally {
    db.close();
  }
}

/** Resolves to { leads, cursor, fullSyncAt } or null. The cache is best-effort and never throws. */
export async function readLeadCache(key) {
  try {
    const value = await runStore('readonly', (store) => store.get(key));
    return Array.isArray(value?.leads) ? value : null;
  } catch {
    return null;
  }
}

export async function writeLeadCache(key, value) {
  try {
    await runStore('readwrite', (store) => store.put(value, key));
  } catch {
    // private browsing / quota exceeded — the CRM still works, it just re-downloads next time
  }
}

/** Called on logout so leads are not left behind on a shared computer. */
export async function clearLeadCache() {
  try {
    await runStore('readwrite', (store) => store.clear());
  } catch {
    // nothing cached
  }
}
